import React from 'react'

import PageHeader from '../../../../Components/UI/PageHeader'
import RulesDataTable from '../../../../Components/sb/rules/rulesIndex/rulesDataTable'

const Rules = () => {
  return (
    <div>
      <PageHeader title="Rules" showButton={true} url={`${process.env.PUBLIC_URL}/rulesstore`}/>
      <RulesDataTable/></div>
  )
}

export default Rules